<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-tone-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 2v15.643l.065.14-.065.029V18h-.402L10 32.734V46H6V30.356l-.065-.139.065-.03V30h.4L38 15.264V2h4zm0 36v8h-4v-8h4zm0-14v8h-4v-8h4zm-32-8v8H6v-8h4zm0-14v8H6V2h4z"/></svg>
</template>
<script>

export default {
  name: 'IconToneAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
